export { ordinal } from './ordinal'
export { plural, singular } from './plural'
export { removeAccents } from './removeAccents'
